import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Icon } from '@vectord/components';
import classNames from 'classnames';

import DeleteSuperBatchModuleButton from '../DeleteSuperBatchModuleButton';
import SuperBatchInterviewRequired from '../SuperBatchInterviewRequired';
import styles from './SuperBatchModulesTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import AddSuperBatchModuleButton from '../AddSuperBatchModuleButton';

function SuperBatchModulesTableRow({ superBatchModule, index }) {
  const { academy_module: academyModule, order } = superBatchModule;
  const { name } = academyModule;

  return (
    <Draggable
      draggableId={String(superBatchModule.id)}
      index={index}
    >
      {({ draggableProps, dragHandleProps, innerRef }, { isDragging }) => (
        <TableRow
          ref={innerRef}
          className={classNames({
            [styles.rowDragActive]: isDragging,
          })}
          {...draggableProps}
        >
          <TableCell>
            <Icon
              name="hamburger"
              {...dragHandleProps}
            />
          </TableCell>
          <TableCell>{order}</TableCell>
          <TableCell>{name}</TableCell>
          <TableCell className={styles.interview}>
            <SuperBatchInterviewRequired superBatchModule={superBatchModule} />
          </TableCell>
          <TableCell>
            <AddSuperBatchModuleButton superBatchModule={superBatchModule} />
          </TableCell>
          <TableCell>
            <DeleteSuperBatchModuleButton superBatchModule={superBatchModule} />
          </TableCell>
        </TableRow>
      )}
    </Draggable>
  );
}

export default SuperBatchModulesTableRow;
